__turbopack_context__.v({
  "heroWithImage": "HeroWithImage-module-scss-module__tAuNKG__heroWithImage",
  "image": "HeroWithImage-module-scss-module__tAuNKG__image",
  "introBlock": "HeroWithImage-module-scss-module__tAuNKG__introBlock",
  "links": "HeroWithImage-module-scss-module__tAuNKG__links",
  "mediaBlock": "HeroWithImage-module-scss-module__tAuNKG__mediaBlock",
  "text": "HeroWithImage-module-scss-module__tAuNKG__text",
});
